import {
  ComponentVariant,
  ComponentSize,
} from 'src/modules/shared/types/component.type';

// Base container classes
export const fileInputContainerClasses: string[] = ['relative', 'w-full'];

// Base classes for the file input display area
export const fileInputBaseClasses: string[] = [
  'rounded-md',
  'transition-all',
  'duration-200',
  'border',
  'flex',
];

// Variant classes for the file input display area
export const fileInputVariantClasses: Record<ComponentVariant, string> = {
  primary: 'border-primary-200 bg-primary-50 text-primary-700',
  secondary: 'border-secondary-200 bg-secondary-50 text-secondary-700',
  neutral: 'border-neutral-200 bg-neutral-50 text-neutral-700',
  danger: 'border-danger-200 bg-danger-50 text-danger-700',
  warning: 'border-warning-200 bg-warning-50 text-warning-700',
  success: 'border-success-200 bg-success-50 text-success-700',
  info: 'border-info-200 bg-info-50 text-info-700',
  whatsapp: 'border-whatsapp-200 bg-whatsapp-50 text-whatsapp-700',
  call: 'border-call-200 bg-call-50 text-call-700',
  email: 'border-email-200 bg-email-50 text-email-700',
};

// Button size mapping for consistency
export const fileInputButtonSizes: Record<ComponentSize, ComponentSize> = {
  '2xs': '2xs',
  xs: '2xs',
  sm: 'xs',
  md: 'sm',
  lg: 'md',
};
